var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.557,
    height: 50.66,
    viewBox: "0 0 41.557 50.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ccc}.cls-2{fill:#8c8c8c}.cls-3{fill:#e3e3e3}.cls-4{fill:#a6a6a6}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "renault"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    d: "M87.5 25.133L73.239.2A.4.4 0 0 0 72.9 0H60.662a.4.4 0 0 0-.343.2L46.053 25.133a.4.4 0 0 0 0 .394l14.266 24.934a.468.468 0 0 0 .028.043.4.4 0 0 0 .115.1.374.374 0 0 0 .152.05.256.256 0 0 0 .047 0H72.9a.4.4 0 0 0 .343-.2L87.5 25.527a.4.4 0 0 0 0-.394zm-27.871.384a.4.4 0 0 1 0-.374l7.145-13.316 7.145 13.316a.4.4 0 0 1 0 .374l-7.14 13.316z",
    className: "cls-1",
    "data-name": "Trazado 392",
    transform: "translate(-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    d: "M296.767 0h-2.312l14.492 25.33-14.492 25.33h2.312a.4.4 0 0 0 .343-.2l14.266-24.934a.4.4 0 0 0 0-.394L297.11.2a.4.4 0 0 0-.343-.2z",
    className: "cls-2",
    "data-name": "Trazado 393",
    transform: "translate(-269.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    d: "M72.889.437l-.995 1.854-3.845 7.168-1.271 2.368-7.145 13.316a.392.392 0 0 0 0 .374l7.145 13.316-1.271 2.367-3.976 7.411-.851 1.589-.219.409-.012.021a.259.259 0 0 1-.079-.074l-.012-.02-.04-.071-14.266-24.938a.4.4 0 0 1 0-.394L60.318.2a.4.4 0 0 1 .343-.2h11.968a.3.3 0 0 1 .26.437z",
    className: "cls-1",
    "data-name": "Trazado 394",
    transform: "translate(-45.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    d: "M72.889.437l-.995 1.854-3.845 7.168-1.271 2.368-7.145 13.316a.392.392 0 0 0 0 .374l7.145 13.316-1.271 2.367-3.976 7.411-.851 1.589-.219.409-.012.021a.259.259 0 0 1-.079-.074l-.012-.02-.04-.071-14.266-24.938a.4.4 0 0 1 0-.394L60.318.2a.4.4 0 0 1 .343-.2h11.968a.3.3 0 0 1 .26.437z",
    className: "cls-3",
    "data-name": "Trazado 395",
    transform: "translate(-45.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_396",
    d: "M171.167 0l-13.491 25.143a.4.4 0 0 0 0 .375l8.416 15.682 1.271-2.368-7.145-13.315a.4.4 0 0 1 0-.375L173.474.437a.3.3 0 0 0-.261-.437z",
    className: "cls-2",
    "data-name": "Trazado 396",
    transform: "translate(-146.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_397",
    d: "M208.055 111.658L194.563 136.8h-2.4a.251.251 0 0 1-.123-.034l.012-.021.219-.409.85-1.584 3.976-7.411 1.271-2.368 7.145-13.316a.4.4 0 0 0 0-.374l-7.145-13.316 1.272-2.367 8.415 15.684a.392.392 0 0 1 0 .374z",
    className: "cls-4",
    "data-name": "Trazado 397",
    transform: "translate(-177.59 -86.141)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenault);
export default __webpack_public_path__ + "static/media/renault.bba078a65b74ed2b9b5b37808f3b6a21.svg";
export { ForwardRef as ReactComponent };